import request from '@/utils/request'
import {cmsServerContext} from '@/config/config'

/**
 * 查询能耗分项
 * @param energyUnitIds
 */
export function getEnergyItem(energyUnitIds) {
  return request({
    url: cmsServerContext + '/EnergyItem/getEnergyItem/' + energyUnitIds,
    method: 'post'
  })
}

/**
 * 分项树
 */
export function energyItemTree() {
  return request({
    url: cmsServerContext + '/EnergyItem/tree',
    method: 'post'
  })
}

/**
 * 分项树
 */
export function saveCustomerDataType(customerId,ids) {
  return request({
    url: cmsServerContext + '/EnergyItem/saveCustomerDataType/' + customerId,
    method: 'post',
    data:ids
  })
}